import {
	IDataListColumn,
	PaginatedAutoDataList,
	PaginatedListFetcherConfig,
	laravelPaginatedListFetchConfig,
} from "@dgs/core";
import { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router";
import { companyService } from "../shared/api/companyService";
import { ICompanyContact } from "../shared/types";

export const CompanyContactList: FC = () => {
	const { t } = useTranslation();
	const { id = "" } = useParams<"id">();
	const navigate = useNavigate();

	const columns = useMemo<IDataListColumn<ICompanyContact>[]>(
		() => [
			{ type: "value", heading: t("Firstname"), valueKey: "firstName" },
			{ type: "value", heading: t("Lastname"), valueKey: "lastName" },
			{ type: "value", heading: t("Position"), valueKey: "position" },
		],
		[t],
	);

	return (
		<PaginatedAutoDataList
			name="companyContacts"
			heading={t("Contacts")}
			empty={t("No contacts available.")}
			columns={columns}
			listFetchConfig={laravelPaginatedListFetchConfig(
				companyService.contactsByCompanyKey(id),
				(config: PaginatedListFetcherConfig<ICompanyContact>) => companyService.contactsByCompany(id, config),
			)}
			onRowClick={(contact) => navigate(`/contacts/active/${contact.id}`)}
			initialSearch={{
				search: "",
				searchFields: [
					{ name: "firstName", label: t("First name") },
					{ name: "lastName", label: t("Last name") },
					{ name: "position", label: t("Position") },
				],
			}}
		/>
	);
};
